// @ts-strict-ignore
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';
import { BackendFeatureFlagsService } from '../services/backend/backend-feature-flags.service';

export const featureFlagsResolver: ResolveFn<Observable<boolean>> = ({ params: { organisationId, boardId } }) => {
  const backendFeatureFlagsService = inject(BackendFeatureFlagsService);
  const appConfigService = inject(AppConfigService);

  boardId ||= appConfigService.appConfig.customHosting?.boardId;

  const isAdminRoute = !organisationId && !boardId;
  const isEditorRoute = !!organisationId && !!boardId;
  const isPublicRoute = !organisationId && !!boardId;

  return isAdminRoute
    ? backendFeatureFlagsService.loadFlagsForAdminRoute()
    : isEditorRoute || isPublicRoute
      ? backendFeatureFlagsService.loadFlagsForEditorOrPublicRoute(boardId)
      : of(false);
};
